import type { RouteRecordRaw } from 'vue-router';

export const solutionRoutes: Array<RouteRecordRaw> = [
  {
    path: '/process',
    name: 'process',
    redirect: '/process/list',
    component: () => import('pages/info/solution/process/McProcess.vue'),
    meta: {
      title: 'Business Processes - Services, requirements, functions...',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'processList',
        component: () => import('pages/info/solution/process/ProcessList.vue'),
        meta: {
          title: 'Business Processes List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'processDetail',
        component: () => import('pages/info/solution/process/ProcessDetail.vue'),
        meta: {
          title: 'Business Process Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'processNew',
        component: () => import('pages/info/solution/process/ProcessNew.vue'),
        meta: {
          title: 'New Business Process',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/process/solution',
    name: 'processSolution',
    redirect: '/process/solution/list',
    component: () =>
      import('pages/info/solution/processSolution/ProcessSolution.vue'),
    meta: {
      title: 'Business Process-Solutions Mapping',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'processSolutionList',
        component: () =>
          import('pages/info/solution/processSolution/ProcessSolutionList.vue'),
        meta: {
          title: 'Business Process-Solutions List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'processSolutionDetail',
        component: () =>
          import('pages/info/solution/processSolution/ProcessSolutionDetail.vue'),
        meta: {
          title: 'Business Process-Solution Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'processSolutionNew',
        component: () =>
          import('pages/info/solution/processSolution/ProcessSolutionNew.vue'),
        meta: {
          title: 'New Business Process-Solution',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/solution',
    name: 'solution',
    redirect: '/solution/list',
    component: () => import('pages/info/solution/solution/McSolution.vue'),
    meta: {
      title: 'Business Solutions',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'solutionList',
        component: () => import('pages/info/solution/solution/SolutionList.vue'),
        meta: {
          title: 'Business Solutions List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'solutionDetail',
        component: () => import('pages/info/solution/solution/SolutionDetail.vue'),
        meta: {
          title: 'Business Solution Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'solutionNew',
        component: () => import('pages/info/solution/solution/SolutionNew.vue'),
        meta: {
          title: 'New Business Solution',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/solution/release',
    name: 'solutionRelease',
    redirect: '/solution/release/list',
    component: () => import('pages/info/solution/release/McRelease.vue'),
    meta: {
      title: 'Business Solution Releases',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'solutionReleaseList',
        component: () => import('pages/info/solution/release/ReleaseList.vue'),
        meta: {
          title: 'Business Solution Releases List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'solutionReleaseDetail',
        component: () => import('pages/info/solution/release/ReleaseDetail.vue'),
        meta: {
          title: 'Business Solution Release Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'solutionReleaseNew',
        component: () => import('pages/info/solution/release/ReleaseNew.vue'),
        meta: {
          title: 'New Business Solution Release',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/process/explorer',
    name: 'processExplorer',
    component: () => import('pages/info/solution/process/ProcessExplorer.vue'),
    meta: {
      title: 'Business Process Explorer',
      requiresAuth: true,
    },
    children: [],
  },
  {
    path: '/process/solution/report',
    name: 'processSolutionReport',
    component: () => import('pages/info/solution/process/ProcessSolutionReport.vue'),
    meta: {
      title: 'Business Process-Solutions Mapping Reports',
      requiresAuth: true,
    },
    children: [],
  },
  {
    path: '/solution/process/report',
    name: 'solutionProcessReport',
    component: () => import('pages/info/solution/process/SolutionProcessReport.vue'),
    meta: {
      title: 'Business Solution-Processes Mapping Reports',
      requiresAuth: true,
    },
    children: [],
  },
  {
    path: '/process/solution/explorer',
    name: 'processSolutionExplorer',
    component: () =>
      import('pages/info/solution/process/ProcessSolutionExplorerDtable.vue'),
    meta: {
      title: 'Business Process-Solutions Mapping Explorer',
      requiresAuth: true,
    },
    children: [],
  },
  {
    path: '/solution/process/explorer',
    name: 'solutionProcessExplorer',
    component: () =>
      import('pages/info/solution/process/SolutionProcessExplorerDtable.vue'),
    meta: {
      title: 'Business Solution-Processes Mapping Explorer',
      requiresAuth: true,
    },
    children: [],
  },
  {
    path: '/solution/release/report',
    name: 'solutionReleaseReport',
    component: () => import('pages/info/solution/solution/SolutionReleaseReport.vue'),
    meta: {
      title: 'Business Solution-Releases Mapping Reports',
      requiresAuth: true,
    },
    children: [],
  },
  {
    path: '/solution/release/explorer',
    name: 'solutionReleaseExplorer',
    component: () =>
      import('pages/info/solution/solution/SolutionReleaseExplorerDtable.vue'),
    meta: {
      title: 'Business Solution-Releases Mapping Explorer',
      requiresAuth: true,
    },
    children: [],
  },
];
